import { useEffect, useMemo, useRef } from "react";
import { useLocation } from "react-router";

export const useLiteTradeSelectAssetFocusSearchInput = () => {
    const searchInputRef = useRef(null);

    const {search} = useLocation();

    const isFocusSearch = useMemo(() => {
        const params = new URLSearchParams(search);
        return !!params.get('focus-search')
    }, [search]);

    useEffect(() => {
        if (isFocusSearch && searchInputRef.current) {
            searchInputRef.current.focus();
        }
    }, [isFocusSearch]);

    return searchInputRef;
}
